import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { BRAND } from "./lib/config";
import { DEMO_SIGNIN, isDemoPath } from "./lib/demo";
import "./styles.css";

// Staging builds only (VITE_DEMO_SIGNIN=on): /demo/ is the demo sign-in page. Elsewhere this is dropped from the bundle.
const DemoPage = DEMO_SIGNIN ? lazy(() => import("./components/DemoPage")) : null;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {DemoPage && isDemoPath() ? (
      <Suspense fallback={null}>
        <DemoPage app="staff" title={`${BRAND.name} staff portal`} logo={BRAND.logoSmall} />
      </Suspense>
    ) : (
      <App />
    )}
  </StrictMode>,
);

// Keep the app on the phone so it opens on site with no signal (see src/sw.template.js).
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => void navigator.serviceWorker.register("/sw.js").catch(() => undefined));
}
